import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as ModifyActions from '../../actions/ModifyProducts';
import * as companiesAction from '../../actions/Companies';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Button, Input, ButtonGroup, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import DeleteProductModal from '../DeleteProductModal';
import WithUserData from '../../HOC/withUserData';
import './ModifyProducts.css';
import { ModifyProductGroups } from './ModifyProductGroups';
import { ModifyOneTimeCharge } from './ModifyOneTimeCharge';
import ModifyInstallationCharge from './ModifyInstallationCharge';
import TemplateAutoComplete from '../TemplateAutocomplete';
import Spinner from '../Spinner/Spinner';

export class ModifyProducts extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');

    this.state = {
      activeCollapse: undefined,
      activeInnerNewCollapse: 0,
      activeTab: 'services',
      isVerizonProducts: true,
      deleteProductName: '',
      templateName: '',
      display: false,
      isLoading: true,
      selectedPGId: '',
      selectedOTCId: '',
      selectedTemplateName: '',
    };
  }

  async componentDidMount() {
    const { user, resetProductGroupsData, setEditMode, setCreateMode, activeTab } = this.props;

    activeTab('services');
    resetProductGroupsData(this.state.activeTab);
    setEditMode(false);
    setCreateMode(false);
    if (user.role === 'superAdmin') {
      this.getAllTemplates();
      this.setState({ isLoading: false });
    }
  }

  getAllTemplates = async () => {
    const { getTemplates, getOneTimeTemplatesByID } = this.props;
    const res = await getTemplates(this.token, 'productGroup');
    this.setState({ selectedPGId: res[0]._id });
    this.setState({ selectedOTCId: res[0].oneTimeTemplate }, async () => {
      await getOneTimeTemplatesByID(this.token, 'oneTimeCharge', this.state.selectedOTCId);
    });
    await getTemplates(this.token, 'installation');
  };

  setEditData = (productGroupsData, mode) => {
    const { setEditMode, setProductGroupsData, resetProductGroupsData } = this.props;
    if (mode) {
      setProductGroupsData(productGroupsData);
    } else {
      resetProductGroupsData(this.state.activeTab);
    }
    setEditMode(mode);
  };

  updateProductGroups = async () => {
    const {
      productGroupsData,
      updateProductGroupsById,
      setEditMode,
      resetProductGroupsData,
      getOneTimeTemplatesByID,
    } = this.props;
    try {
      await updateProductGroupsById(this.token, productGroupsData._id, productGroupsData);
      setEditMode(false);
      resetProductGroupsData(this.state.activeTab);
      await getOneTimeTemplatesByID(this.token, 'productGroup', this.state.selectedPGId);
    } catch (error) {
      // @TODO
      // handle errors
    }
  };

  updateOTCProductGroups = async () => {
    const {
      productGroupsData,
      updateOTCProductGroupsById,
      setEditMode,
      resetProductGroupsData,
      getOneTimeTemplatesByID,
    } = this.props;
    try {
      await updateOTCProductGroupsById(this.token, productGroupsData._id, productGroupsData);
      setEditMode(false);
      resetProductGroupsData(this.state.activeTab);
      await getOneTimeTemplatesByID(this.token, 'oneTimeCharge', this.state.selectedOTCId);
    } catch (error) {
      // @TODO
      // handle errors
    }
  };

  updateInstallationProductGroups = async () => {
    const {
      productGroupsData,
      updateInstallationGroupsById,
      setEditMode,
      resetProductGroupsData,
      getOneTimeTemplatesByID,
    } = this.props;
    try {
      await updateInstallationGroupsById(this.token, productGroupsData._id, productGroupsData);
      setEditMode(false);
      resetProductGroupsData(this.state.activeTab);
      await getOneTimeTemplatesByID(this.token, 'oneTimeCharge', this.state.selectedOTCId);
    } catch (error) {
      // @TODO
      // handle errors
    }
  };

  saveProductGroups = async () => {
    const {
      productGroupsData,
      setCreateMode,
      resetProductGroupsData,
      insertProductGroupsByID,
      getOneTimeTemplatesByID,
    } = this.props;
    try {
      delete productGroupsData._id;
      await insertProductGroupsByID(this.token, this.state.selectedPGId, productGroupsData);
      setCreateMode(false);
      resetProductGroupsData(this.state.activeTab);
      await getOneTimeTemplatesByID(this.token, 'productGroup', this.state.selectedPGId);
    } catch (error) {
      // @TODO
      // handle errors
    }
  };

  saveOTCProductGroups = async () => {
    const {
      productGroupsData,
      setCreateMode,
      resetProductGroupsData,
      insertOTCGroup,
      getOneTimeTemplatesByID,
    } = this.props;

    try {
      delete productGroupsData._id;
      if (this.state.activeTab === 'equipment') {
        productGroupsData.type = 'equipment';
      } else if (this.state.activeTab === 'installation') {
        productGroupsData.type = 'installation';
      }
      await insertOTCGroup(this.token, this.state.selectedOTCId, productGroupsData);
      setCreateMode(false);
      resetProductGroupsData(this.state.activeTab);
      await getOneTimeTemplatesByID(this.token, 'oneTimeCharge', this.state.selectedOTCId);
    } catch (error) {
      // @TODO
      // handle errors
    }
  };

  toggle = async tab => {
    const { activeTab, resetProductGroupsData, setCreateMode, setEditMode } = this.props;
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
      activeTab(tab);
      resetProductGroupsData(tab);
      setCreateMode(false);
      setEditMode(false);
    }
  };

  handleDeleteProductGroup = (name, value) => {
    const { showDeleteModal } = this.props;
    this.setState({ deleteProductName: name, deleteProductID: value });
    this.deleteProductID = value;
    showDeleteModal();
  };

  deleteProductGp = async () => {
    const {
      cancelDeleteProduct,
      deleteProductGroupByTemplateId,
      getOneTimeTemplatesByID,
      deleteOtcProductGroupByTemplateId,
    } = this.props;

    const { activeTab, deleteProductName, deleteProductID } = this.state;
    if (deleteProductName === 'productGroup') {
      var res = await deleteProductGroupByTemplateId(
        this.token,
        deleteProductID,
        this.state.selectedPGId,
      );
    } else {
      var res = await deleteOtcProductGroupByTemplateId(
        this.token,
        deleteProductID,
        this.state.selectedOTCId,
      );
    }
    cancelDeleteProduct();
    if (res) {
      if (activeTab === 'services') {
        await getOneTimeTemplatesByID(this.token, 'productGroup', this.state.selectedPGId);
      } else {
        await getOneTimeTemplatesByID(this.token, 'oneTimeCharge', this.state.selectedOTCId);
      }
    }
  };

  addTemplate = async (type, template) => {
    const { addTemplates, productGroupTemplate, otc_template } = this.props;
    this.setState({ isLoading: true });
    const otc_res = await addTemplates(
      this.token,
      type,
      this.getUpdatedTemplate(otc_template, 'oneTimeCharges'),
    );

    if (otc_res) {
      await this.addProductGroup(otc_res, 'productGroup');
    }
    this.setState({ isLoading: false, display: false });
  };

  addProductGroup = async (otc_id, type) => {
    const { addTemplates, getTemplates, productGroupTemplate } = this.props;
    const res = await addTemplates(
      this.token,
      type,
      this.getUpdatedTemplate(productGroupTemplate, 'productGroupCharges', otc_id),
    );
    if (res) {
      await getTemplates(this.token, type);
    }
  };

  getUpdatedTemplate = (template, type, otc_id, inst_id) => {
    let newTemplate = JSON.parse(
      JSON.stringify(type === 'oneTimeCharges' ? template : template[0]),
    );
    newTemplate.templateName = this.state.templateName;
    delete newTemplate._id;
    let pgroup = [];
    newTemplate[type].forEach(item => {
      pgroup.push(item._id);
    });
    newTemplate[type] = pgroup;
    if (otc_id) {
      newTemplate.oneTimeTemplate = otc_id;
    }
    return newTemplate;
  };

  render() {
    const {
      user,
      productGroups,
      oneTimeCharge,
      installation,
      editMode,
      productGroupsData,
      onFieldProductGroupsUpdate,
      onFieldProductUpdate,
      onFieldProductPriceUpdate,
      onOTCProductPriceUpdate,
      addProduct,
      addOTCProduct,
      deleteProduct,
      showDeleteModal,
      cancelDeleteProduct,
      deleteProductObj,
      isNewProductGroups,
      setCreateMode,
      resetProductGroupsData,
      productGroupTemplate,
      oneTimeChargeTemplate,
      getOneTimeTemplatesByID,
    } = this.props;

    const { activeTab, deleteProductName, isLoading } = this.state;
    if (!user || !user._id) {
      return <Redirect to="/" />;
    }
    if (user.role !== 'superAdmin') {
      return <Redirect to="/login" />;
    }
    return (
      <Container fluid>
        {isLoading && <Spinner />}
        <div className="viewContainer" style={{ padding: '0px 20px 20px 20px' }}>
          <div className="modify-products-wrapper">
            <ButtonGroup className="tab-group tab-group-services">
              <Button
                className={classnames({ 'active left': activeTab === 'services' })}
                onClick={() => {
                  this.toggle('services');
                }}
              >
                Services
              </Button>
              <Button
                className={classnames({ active: activeTab === 'equipment' })}
                onClick={() => {
                  this.toggle('equipment');
                }}
              >
                Equipment
              </Button>
              <Button
                className={classnames({ active: activeTab === 'installation' })}
                onClick={() => {
                  this.toggle('installation');
                }}
              >
                Installation
              </Button>
            </ButtonGroup>
            <TabContent activeTab={activeTab}>
              {activeTab === 'services' && (
                <TabPane tabId="services">
                  <Row>
                    <Col
                      md={{ size: 3 }}
                      sm={{ size: 6 }}
                      style={{ display: 'flex', alignItems: 'start', flexDirection: 'column' }}
                    >
                      <TemplateAutoComplete
                        searchTerm={
                          this.state.selectedTemplateName || productGroupTemplate[0]?.templateName
                        }
                        templates={productGroupTemplate}
                        onChange={e =>
                          e.suggestion !== null
                            ? (this.setState({
                                selectedPGId: e.suggestion._id,
                                selectedOTCId: e.suggestion.oneTimeTemplate,
                                selectedTemplateName: e.value,
                              }),
                              getOneTimeTemplatesByID(this.token, 'productGroup', e.suggestion._id),
                              getOneTimeTemplatesByID(
                                this.token,
                                'oneTimeCharge',
                                e.suggestion.oneTimeTemplate,
                              ))
                            : ''
                        }
                      />
                      {productGroupTemplate.length !== 0 && (
                        <>
                          {!this.state.display ? (
                            <Button
                              className="px-0 add-template-btn"
                              onClick={() => this.setState({ display: true })}
                            >
                              <FontAwesomeIcon
                                icon="plus"
                                size="sm"
                                color="#29a4ff"
                                style={{ marginRight: '1rem' }}
                              />
                              Add Template
                            </Button>
                          ) : (
                            <div
                              className="my-2 btn-group"
                              style={{ display: 'flex', width: '100%' }}
                            >
                              <Input
                                placeholder="Add Template"
                                required
                                type="text"
                                name="addtemplate"
                                value={this.state.templateName}
                                onChange={e => this.setState({ templateName: e.target.value })}
                              />
                              <Button
                                className=""
                                color="success"
                                onClick={() =>
                                  this.addTemplate('oneTimeCharge', oneTimeChargeTemplate)
                                }
                              >
                                Save
                              </Button>
                              <Button
                                className=""
                                color="danger"
                                onClick={() => this.setState({ templateName: '', display: false })}
                              >
                                Cancel
                              </Button>
                            </div>
                          )}
                        </>
                      )}
                    </Col>

                    <Col md={{ size: 9 }} sm={{ size: 6 }}>
                      <Button
                        className="float-right"
                        style={{ marginBottom: '20px' }}
                        disabled={editMode || isNewProductGroups}
                        onClick={() => {
                          this.setState(
                            { activeCollapse: productGroups.length, activeInnerNewCollapse: 0 },
                            () => {
                              setCreateMode(!isNewProductGroups);
                            },
                          );
                        }}
                      >
                        Add Product Groups
                      </Button>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <ModifyProductGroups
                        deleteProductGroup={(name, value) => {
                          this.handleDeleteProductGroup(name, value);
                        }}
                        setCreateMode={setCreateMode}
                        deleteProduct={e => {
                          deleteProduct(e);
                        }}
                        resetProductGroupsData={() => resetProductGroupsData(activeTab)}
                        isNewProductGroups={isNewProductGroups}
                        showDeleteModal={showDeleteModal}
                        updateProductGroups={this.updateProductGroups}
                        onFieldProductGroupsUpdate={onFieldProductGroupsUpdate}
                        onFieldProductUpdate={onFieldProductUpdate}
                        onFieldProductPriceUpdate={onFieldProductPriceUpdate}
                        addProduct={addProduct}
                        editMode={editMode}
                        setEditData={this.setEditData}
                        productGroupsData={productGroupsData}
                        productGroups={productGroups}
                        saveProductGroups={this.saveProductGroups}
                      />
                    </Col>
                  </Row>
                </TabPane>
              )}
              {activeTab === 'equipment' && (
                <TabPane tabId="equipment">
                  <Row>
                    <Col md={{ size: 4, offset: 8 }}>
                      <Button
                        className="float-right"
                        style={{ marginBottom: '20px' }}
                        disabled={editMode || isNewProductGroups}
                        onClick={() => {
                          this.setState(
                            { activeCollapse: oneTimeCharge.length, activeInnerNewCollapse: 0 },
                            () => {
                              setCreateMode(!isNewProductGroups);
                            },
                          );
                        }}
                      >
                        Add One Time Charge
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <ModifyOneTimeCharge
                        deleteProductGroup={(name, value) =>
                          this.handleDeleteProductGroup(name, value)
                        }
                        setCreateMode={setCreateMode}
                        deleteProduct={e => {
                          deleteProduct(e);
                        }}
                        resetProductGroupsData={() => resetProductGroupsData(activeTab)}
                        isNewProductGroups={isNewProductGroups}
                        showDeleteModal={showDeleteModal}
                        updateOTCProductGroups={this.updateOTCProductGroups}
                        onFieldProductGroupsUpdate={onFieldProductGroupsUpdate}
                        onFieldProductUpdate={onFieldProductUpdate}
                        onOTCProductPriceUpdate={onOTCProductPriceUpdate}
                        addProduct={addOTCProduct}
                        editMode={editMode}
                        setEditData={this.setEditData}
                        productGroupsData={productGroupsData}
                        oneTimeCharge={oneTimeCharge}
                        saveOTCProductGroups={this.saveOTCProductGroups}
                      />
                    </Col>
                  </Row>
                </TabPane>
              )}
              {activeTab === 'installation' && (
                <TabPane tabId="installation">
                  <Row>
                    <Col md={{ size: 4, offset: 8 }}>
                      <Button
                        className="float-right"
                        style={{ marginBottom: '20px' }}
                        disabled={editMode || isNewProductGroups}
                        onClick={() => {
                          this.setState(
                            { activeCollapse: installation.length, activeInnerNewCollapse: 0 },
                            () => {
                              setCreateMode(!isNewProductGroups);
                            },
                          );
                        }}
                      >
                        Add Installation Charge
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <ModifyInstallationCharge
                        deleteProductGroup={(name, value) =>
                          this.handleDeleteProductGroup(name, value)
                        }
                        setCreateMode={setCreateMode}
                        deleteProduct={e => {
                          deleteProduct(e);
                        }}
                        resetProductGroupsData={() => resetProductGroupsData(activeTab)}
                        isNewProductGroups={isNewProductGroups}
                        showDeleteModal={showDeleteModal}
                        updateInstallationProductGroups={this.updateInstallationProductGroups}
                        onFieldProductGroupsUpdate={onFieldProductGroupsUpdate}
                        onFieldProductUpdate={onFieldProductUpdate}
                        onFieldProductPriceUpdate={onOTCProductPriceUpdate}
                        addProduct={addOTCProduct}
                        editMode={editMode}
                        setEditData={this.setEditData}
                        productGroupsData={productGroupsData}
                        installation={oneTimeCharge}
                        saveInstallationProductGroups={this.saveOTCProductGroups}
                      />
                    </Col>
                  </Row>
                </TabPane>
              )}
            </TabContent>
          </div>
          <DeleteProductModal
            deleteProduct={deleteProductName}
            isOpen={deleteProductObj.isOpen}
            onCancel={async e => {
              setTimeout(() => {
                this.setState({ deleteProductName: '' });
              }, 500);
              await cancelDeleteProduct(e);
            }}
            onConfirm={() => {
              if (deleteProductName === '') {
                deleteProduct(deleteProductObj.index);
              } else {
                this.deleteProductGp();
              }
            }}
          />
        </div>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
  productGroups: state.AppState.modifyProducts.productGroups,
  oneTimeCharge: state.AppState.modifyProducts.oneTimeCharge,
  installation: state.AppState.modifyProducts.installation,
  editMode: state.UIState.modifyProducts.editMode,
  productGroupsData: state.UIState.modifyProducts.productGroupsData,
  deleteProductObj: state.UIState.modifyProducts.showDeleteModal,
  isNewProductGroups: state.UIState.modifyProducts.isNewProductGroups,
  isVerizonProducts: state.UIState.proposalEditor.isVerizonProducts,
  productGroupTemplate: state.AppState.modifyProducts.productGroupTemplate,
  oneTimeChargeTemplate: state.AppState.modifyProducts.oneTimeChargeTemplate,
  otc_template: state.AppState.modifyProducts.otc_template,
});

const mapDispatchToProps = dispatch => ({
  getProductGroupsByCompany: (token, cid) =>
    dispatch(ModifyActions.getProductGroupsByCompany(token, cid)),
  getOTCByCompany: (token, cid) => dispatch(ModifyActions.getOTCByCompany(token, cid)),
  getInstallationChargesByCompany: (token, cid) =>
    dispatch(ModifyActions.getInstallationChargesByCompany(token, cid)),
  insertProductGroupsIntoCompany: (token, cid, productGroups) =>
    dispatch(ModifyActions.insertProductGroupsIntoCompany(token, cid, productGroups)),
  insertOTCGroup: (token, tid, productGroups) =>
    dispatch(ModifyActions.insertOTCGroup(token, tid, productGroups)),
  insertInstallationGroupsIntoCompany: (token, cid, productGroups) =>
    dispatch(ModifyActions.insertInstallationGroupsIntoCompany(token, cid, productGroups)),
  updateProductGroupsById: (token, pgid, productGroups) =>
    dispatch(ModifyActions.updateProductGroupsById(token, pgid, productGroups)),
  updateOTCProductGroupsById: (token, pgid, productGroups) =>
    dispatch(ModifyActions.updateOTCProductGroupsById(token, pgid, productGroups)),
  updateInstallationGroupsById: (token, pgid, productGroups) =>
    dispatch(ModifyActions.updateInstallationGroupsById(token, pgid, productGroups)),
  setEditMode: mode => dispatch(ModifyActions.setEditMode(mode)),
  setProductGroupsData: productGroupsData =>
    dispatch(ModifyActions.setProductGroupsData(productGroupsData)),
  resetProductGroupsData: tab => dispatch(ModifyActions.resetProductGroupsData(tab)),
  onFieldProductGroupsUpdate: (name, value) =>
    dispatch(ModifyActions.onFieldProductGroupsUpdate(name, value)),
  onFieldProductUpdate: (productIndex, name, value) =>
    dispatch(ModifyActions.onFieldProductUpdate(productIndex, name, value)),
  onFieldProductPriceUpdate: (productIndex, key, price) =>
    dispatch(ModifyActions.onFieldProductPriceUpdate(productIndex, key, price)),
  onOTCProductPriceUpdate: (productIndex, key, price) =>
    dispatch(ModifyActions.onOTCProductPriceUpdate(productIndex, key, price)),
  addProduct: () => dispatch(ModifyActions.addProduct()),
  addOTCProduct: () => dispatch(ModifyActions.addOTCProduct()),
  deleteProduct: productIndex => dispatch(ModifyActions.deleteProduct(productIndex)),
  deleteProductGroup: (token, id) => dispatch(ModifyActions.deleteProductGroup(token, id)),
  deleteOtcProductGroup: (token, cid, pid) =>
    dispatch(ModifyActions.deleteOtcProductGroup(token, cid, pid)),
  deleteInstProductGroup: (token, cid, pid) =>
    dispatch(ModifyActions.deleteInstProductGroup(token, cid, pid)),
  showDeleteModal: productIndex => dispatch(ModifyActions.showDeleteModal(productIndex)),
  cancelDeleteProduct: () => dispatch(ModifyActions.cancelDeleteProduct()),
  setCreateMode: mode => dispatch(ModifyActions.setCreateMode(mode)),
  activeTab: tab => dispatch(ModifyActions.activeTab(tab)),
  getCompanies: token => dispatch(companiesAction.getCompanies(token)),
  getTemplates: (token, type) => dispatch(ModifyActions.getTemplates(token, type)),
  productGroupList: productGroup => dispatch(ModifyActions.productGroupList(productGroup)),
  oneTimeChargeGroupList: productGroup =>
    dispatch(ModifyActions.oneTimeChargeGroupList(productGroup)),
  installationGroupList: productGroup =>
    dispatch(ModifyActions.installationGroupList(productGroup)),
  addTemplates: (token, type, template) =>
    dispatch(ModifyActions.addTemplates(token, type, template)),
  getOneTimeTemplatesByID: (token, type, id) =>
    dispatch(ModifyActions.getOneTimeTemplatesByID(token, type, id)),
  insertProductGroupsByID: (token, tId, productGroups) =>
    dispatch(ModifyActions.insertProductGroupsByID(token, tId, productGroups)),
  deleteProductGroupByTemplateId: (token, pgId, tId) =>
    dispatch(ModifyActions.deleteProductGroupByTemplateId(token, pgId, tId)),
  deleteOtcProductGroupByTemplateId: (token, pgId, tId) =>
    dispatch(ModifyActions.deleteOtcProductGroupByTemplateId(token, pgId, tId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(ModifyProducts));
